module.exports = __webpack_public_path__ + "media/images/icon-failure-998b921cf19c5a852db10187f3e43c63.png";